import { authenticatedFetch } from './authenticatedFetch';

const MAX_CONCURRENT_IMAGE_REQUESTS = 3;
let activeRequests = 0;
const highPriorityWaiters: Array<() => void> = [];
const normalPriorityWaiters: Array<() => void> = [];

const acquire = async (priority: 'high' | 'normal'): Promise<void> => {
  if (activeRequests < MAX_CONCURRENT_IMAGE_REQUESTS) {
    activeRequests += 1;
    return;
  }
  await new Promise<void>((resolve) => {
    (priority === 'high' ? highPriorityWaiters : normalPriorityWaiters).push(
      resolve
    );
  });
  activeRequests += 1;
};

const release = (): void => {
  activeRequests = Math.max(0, activeRequests - 1);
  (highPriorityWaiters.shift() || normalPriorityWaiters.shift())?.();
};

export const fetchProtectedImage = async (
  src: string,
  signal: AbortSignal,
  priority: 'high' | 'normal' = 'normal'
): Promise<Response> => {
  await acquire(priority);
  try {
    if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
    return await authenticatedFetch(src, { signal });
  } finally {
    release();
  }
};
